import { CSSProperties, ReactNode } from 'react'
import './tn-input.less'
import { Input } from 'antd'
import classNames from 'classnames'

/**
 * 若是需要添加校验或需要提示的input推荐使用form表单进行检验，例子如下：
    <Form.Item
       validateTrigger="onBlur"   // 失焦的时候触发校验
       style={{ textAlign: 'left' }}
       rules={[{ required: true, message: "必填" }]} // 必填校验
       name="inputValue"
       help={<div style={{ wordBreak: 'break-all' }}>{helpValue}</div>}// 自动换行提示
       >
       <Input />
    </Form.Item>
 */


interface Iprops {
    // 输入框的值
    value?: any
    // 输入框className
    className?: string
    // 输入框单独样式
    style?: CSSProperties
    // 输入框后方icon
    suffix?: ReactNode
    // 输入框前方icon
    prefix?: ReactNode
    // 输入框提示语
    placeholder?: string
    // 输入框默认值
    defaultValue?: string
    // 输入框尺寸：中|小，默认中尺寸
    size?: "middle" | "small"
    allowClear?: boolean | { clearIcon: ReactNode }
    // 自动聚焦
    autoFocus?: boolean
    ref?: any
    onTextChange?: (e) => void
    onBlur?: (str: string) => void
    onFocus?: () => void
    onPressEnter?: (str: string) => void
    onEscapeKeyDown?: () => void
}

export default function TnInput(props: Iprops) {

    return (
        <div className={classNames({
            "tn-input-wrap": true,
            "tn-input-wrap-small": props?.size == "small"
        })}>
            <Input
                ref={props?.ref || null}
                autoFocus={props?.autoFocus}
                type="text"
                allowClear={props?.allowClear}
                value={props?.value}
                defaultValue={props?.defaultValue}
                className={`tn-input ${props?.className || ''}`}
                style={props?.style}
                suffix={props?.suffix || <></>}
                prefix={props?.prefix || <></>}
                placeholder={props?.placeholder || ''}
                onChange={(e) => {
                    if (props?.onTextChange) {
                        props.onTextChange(e.target.value);
                    }
                }}
                onBlur={(e) => {
                    if (props?.onBlur) {
                        props.onBlur(e.target.value);
                    }
                }}
                onFocus={() => {
                    if (props?.onFocus) {
                        props.onFocus();
                    }
                }}
                onPressEnter={(e) => {
                    if (props?.onPressEnter) {
                        props.onPressEnter((e.target as HTMLInputElement).value);
                    }
                }}
                onKeyDown={(e) => {
                    if (props?.onEscapeKeyDown && e.key === 'Escape') {
                        props.onEscapeKeyDown();
                    }
                }}
            />
        </div>
    )
}